<template>

    <v-dialog v-model="visible" :width="width" persistent>

        <v-card>

            <v-card-title class="headline">

                {{ title }}

            </v-card-title>

            <v-card-text v-if="!requireCheck">

                {{ message }}

            </v-card-text>

            <v-card-text v-if="requireCheck">

                <v-layout row>

                    <v-flex md1>

                        <v-checkbox
                            v-model="checked"
                        />

                    </v-flex>

                    <v-flex v-html="message" md11 style="text-align: justify;"></v-flex>

                </v-layout>

            </v-card-text>

            <v-card-actions>

                <v-btn
                    :disabled="okButtonDisabled"
                    color="secondaryButtonColor"
                    style="color: var(--v-secondaryButtonTextColor-base)"
                    text @click="okClicked()">
                    {{ okText }}</v-btn>

                <v-btn
                    v-if="closeText"
                    color="secondaryButtonColor"
                    style="color: var(--v-secondaryButtonTextColor-base)"
                    text
                    @click="closeClicked()">
                    {{ closeText }}</v-btn>

            </v-card-actions>

        </v-card>

    </v-dialog>

</template>

<script>
export default {
    name: 'BnConfirmDialog',
    computed: {
        okButtonDisabled() {
            if (this.requireCheck) {
                return !this.checked;
            }
            return false;
        },
    },
    data() {
        return {
            visible: false,
            okFn: null,
            okText: '',
            closeFn: '',
            closeText: '',
            title: '',
            message: '',
            width: 600,
            requireCheck: false,
            checked: false,
        };
    },
    methods: {
        openWithConfig({
            okFn = this.close,
            okText = 'Rendben',
            closeFn = this.close,
            closeText = '',
            title = '',
            message = '',
            width = 600,
            requireCheck = false,
        } = {}) {
            // eslint-disable-next-line prefer-rest-params
            this.visible = true;
            this.okFn = okFn;
            this.okText = okText;
            this.closeFn = closeFn;
            this.closeText = closeText;
            this.title = title;
            this.message = message;
            this.width = width;
            this.requireCheck = requireCheck;
        },
        close() {
            this.visible = false;
        },
        okClicked() {
            this.okFn();
            this.close();
        },
        closeClicked() {
            this.closeFn();
            this.close();
        },
    },
};
</script>

<style scoped>

</style>
